export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';
export const IN_OUT = 'inOut';
export const IN = 'in';
export const OUT = 'out';
